import { render, staticRenderFns } from "./shared_groups_empty_state.vue?vue&type=template&id=15bda96e"
import script from "./shared_groups_empty_state.vue?vue&type=script&lang=js"
export * from "./shared_groups_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports